module.exports = __webpack_public_path__ + "img/bottom-icon1.8b0f38ef.png";